import { gql } from "@apollo/client";
import ReactableFields from "../../../lib/graphql/fragments/ReactableFields";

export default gql`
  mutation AddReaction($input: AddReactionInput!) {
    addReaction(input: $input) {
      ... on AssetDiscussionComment {
        _id
        ...ReactableFields
      }
      ... on AssetDiscussionCommentReply {
        _id
        ...ReactableFields
      }
    }
  }

  ${ReactableFields}
`;
